export default "__VITE_ASSET__B1UKJza9__"